var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('section', {
    staticClass: "section"
  }, [_c('h3', {
    staticClass: "title is-4"
  }, [_vm._v("Welcome")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Thank you for registering, you are now logged in.\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n            Read our Getting Started documentation for information about managing associations and direct link requests.\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link is-outlined",
    attrs: {
      "to": "/documentation"
    }
  }, [_vm._v("Getting Started")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n            Start managing associations and generating certificates.\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link is-outlined",
    attrs: {
      "to": "/associations"
    }
  }, [_vm._v("Manage Associations")])], 1)])])]), _vm._v(" "), _c('Footer')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04971b5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome.vue
// module id = rA7G
// module chunks = 1